export var DebtorType;
(function (DebtorType) {
    DebtorType["person"] = "P";
    DebtorType["independent"] = "S";
    DebtorType["company"] = "F";
})(DebtorType || (DebtorType = {}));
export var FoundationCode;
(function (FoundationCode) {
    FoundationCode["betalingsp\u00E5krav1p\u00E5tegning"] = "A";
    FoundationCode["betalingsp\u00E5krav2p\u00E5tegning"] = "B";
    FoundationCode["st\u00E6vning"] = "C";
    FoundationCode["fogedsag"] = "D";
    FoundationCode["dom"] = "E";
    FoundationCode["insolvens"] = "F";
    FoundationCode["konkurs"] = "I";
    FoundationCode["tvangsakkord"] = "K";
    FoundationCode["retsforlig"] = "L";
    FoundationCode["fogedretsrekv"] = "P";
    FoundationCode["offentliginberetning"] = "S";
    FoundationCode["tvangsauktion"] = "T";
    FoundationCode["tvangsauktionudl\u00E6g"] = "U";
    FoundationCode["g\u00E6ldssanering"] = "W";
    FoundationCode["skylderkl\u00E6ring"] = "Y";
    FoundationCode["forlig"] = "Z";
    FoundationCode["speciel"] = "X";
})(FoundationCode || (FoundationCode = {}));
export var DeleteReasons;
(function (DeleteReasons) {
    DeleteReasons["BET"] = "BET";
    DeleteReasons["AIN"] = "AIN";
    DeleteReasons["D\u00D8D"] = "D\u00D8D";
    DeleteReasons["TFY"] = "TFY";
    DeleteReasons["GAL"] = "GAL";
    DeleteReasons["VTT"] = "VTT";
    DeleteReasons["TAF"] = "TAF";
    DeleteReasons["STR"] = "STR";
    DeleteReasons["DER"] = "DER";
})(DeleteReasons || (DeleteReasons = {}));
export const deleteReasonTexts = {
    [DeleteReasons.BET]: 'Fordring betalt',
    [DeleteReasons.AIN]: 'Aftale indgået med skyldner',
    [DeleteReasons.DØD]: 'Skyldner er afgået ved døden',
    [DeleteReasons.TFY]: 'Tvangsakkord fyldestgjort',
    [DeleteReasons.GAL]: 'Gældssanering – al gæld bortfalder',
    [DeleteReasons.VTT]: 'Varen taget retur',
    [DeleteReasons.TAF]: 'Tvangsauktion aflyst',
    [DeleteReasons.STR]: 'Der er strid i sagen',
    [DeleteReasons.DER]: 'Andet – vi ønsker skyldner slettet',
};
export class RKIError extends Error {
    constructor(message) {
        super(message);
        this.name = 'RKIError';
    }
}
export const isDebtorPMV = (details) => {
    const companyTypeIsPMV = details?.virksomhedsform && details?.isCompany
        ? ['Personligt ejet Mindre Virksomhed', 'Enkeltmandsvirksomhed'].includes(details.virksomhedsform)
        : false;
    const nameIncludesV = (details?.name || '').toLocaleLowerCase().indexOf(' v/') !== -1;
    return companyTypeIsPMV || nameIncludesV;
};
//# sourceMappingURL=rki.js.map